import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _45f27b28 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _b2b97288 = () => interopDefault(import('../pages/checkout-workshop.vue' /* webpackChunkName: "pages/checkout-workshop" */))
const _131a4860 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _467c2912 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _01107f6e = () => interopDefault(import('../pages/my-account.vue' /* webpackChunkName: "pages/my-account" */))
const _09a1891e = () => interopDefault(import('../pages/my-account/index.vue' /* webpackChunkName: "pages/my-account/index" */))
const _165f5730 = () => interopDefault(import('../pages/my-account/loyalty-card.vue' /* webpackChunkName: "pages/my-account/loyalty-card" */))
const _bdbca01c = () => interopDefault(import('../pages/my-account/my-addresses.vue' /* webpackChunkName: "pages/my-account/my-addresses" */))
const _b9d69f0e = () => interopDefault(import('../pages/my-account/my-profile.vue' /* webpackChunkName: "pages/my-account/my-profile" */))
const _11ef648c = () => interopDefault(import('../pages/my-account/notebook.vue' /* webpackChunkName: "pages/my-account/notebook" */))
const _3ebc9a92 = () => interopDefault(import('../pages/my-account/order-history/index.vue' /* webpackChunkName: "pages/my-account/order-history/index" */))
const _08b28d4e = () => interopDefault(import('../pages/my-account/referral.vue' /* webpackChunkName: "pages/my-account/referral" */))
const _7b0e7376 = () => interopDefault(import('../pages/my-account/wishlist.vue' /* webpackChunkName: "pages/my-account/wishlist" */))
const _496fc3fc = () => interopDefault(import('../pages/my-account/notebook-details/_slug.vue' /* webpackChunkName: "pages/my-account/notebook-details/_slug" */))
const _396ec67a = () => interopDefault(import('../pages/my-account/order-historical-details/_id.vue' /* webpackChunkName: "pages/my-account/order-historical-details/_id" */))
const _2b9af6df = () => interopDefault(import('../pages/my-account/order-history/_id.vue' /* webpackChunkName: "pages/my-account/order-history/_id" */))
const _0a95363b = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _694b1888 = () => interopDefault(import('../pages/set-password.vue' /* webpackChunkName: "pages/set-password" */))
const _1981cbf8 = () => interopDefault(import('../pages/signin.vue' /* webpackChunkName: "pages/signin" */))
const _07d5707a = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _0c1b0d4b = () => interopDefault(import('../pages/legacy/Survey/Survey.vue' /* webpackChunkName: "pages/legacy/Survey/Survey" */))
const _329b96dd = () => interopDefault(import('../pages/all-advices.vue' /* webpackChunkName: "pages/all-advices" */))
const _7a61f4be = () => interopDefault(import('../pages/legacy/AllProducts.vue' /* webpackChunkName: "pages/legacy/AllProducts" */))
const _640f7fee = () => interopDefault(import('../pages/legacy/ThankYou.vue' /* webpackChunkName: "pages/legacy/ThankYou" */))
const _a30923c8 = () => interopDefault(import('../pages/dev/error.vue' /* webpackChunkName: "pages/dev/error" */))
const _2b3a1cd9 = () => interopDefault(import('../pages/guides.vue' /* webpackChunkName: "pages/guides" */))
const _76cdba16 = () => interopDefault(import('../pages/legacy/FAQ/Index.vue' /* webpackChunkName: "pages/legacy/FAQ/Index" */))
const _82975c32 = () => interopDefault(import('../pages/legacy/FAQ/ContactForm.vue' /* webpackChunkName: "pages/legacy/FAQ/ContactForm" */))
const _3b7f48c8 = () => interopDefault(import('../pages/legacy/Survey/SurveyResult.vue' /* webpackChunkName: "pages/legacy/Survey/SurveyResult" */))
const _4e5d0669 = () => interopDefault(import('../pages/legacy/Basic/Basic.vue' /* webpackChunkName: "pages/legacy/Basic/Basic" */))
const _c1a4aa6a = () => interopDefault(import('../pages/legacy/Recipe/Recipe.vue' /* webpackChunkName: "pages/legacy/Recipe/Recipe" */))
const _6de2820f = () => interopDefault(import('../pages/legacy/Recipe/RecipeScript.ts' /* webpackChunkName: "pages/legacy/Recipe/RecipeScript" */))
const _6a880d14 = () => interopDefault(import('../pages/legacy/SearchResults/SearchResultsEmpty.vue' /* webpackChunkName: "pages/legacy/SearchResults/SearchResultsEmpty" */))
const _74c51a32 = () => interopDefault(import('../pages/legacy/Survey/SurveyResultScript.ts' /* webpackChunkName: "pages/legacy/Survey/SurveyResultScript" */))
const _3dd485ce = () => interopDefault(import('../pages/legacy/Survey/TabComponent.vue' /* webpackChunkName: "pages/legacy/Survey/TabComponent" */))
const _1a40ec10 = () => interopDefault(import('../pages/legacy/SurveyResult/GenericSurveyResultScript.ts' /* webpackChunkName: "pages/legacy/SurveyResult/GenericSurveyResultScript" */))
const _7a9be437 = () => interopDefault(import('../pages/legacy/GenericCategory/GenericCategory.vue' /* webpackChunkName: "pages/legacy/GenericCategory/GenericCategory" */))
const _0a59a7e5 = () => interopDefault(import('../pages/legacy/Basic/_slug.vue' /* webpackChunkName: "pages/legacy/Basic/_slug" */))
const _e4236976 = () => interopDefault(import('../pages/guide/_slug.vue' /* webpackChunkName: "pages/guide/_slug" */))
const _2b0c29d4 = () => interopDefault(import('../pages/legacy/Invoice/_id.vue' /* webpackChunkName: "pages/legacy/Invoice/_id" */))
const _3ade256c = () => interopDefault(import('../pages/page/_slug.vue' /* webpackChunkName: "pages/page/_slug" */))
const _607ea60d = () => interopDefault(import('../pages/pages/_slug.vue' /* webpackChunkName: "pages/pages/_slug" */))
const _0ceec3f8 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _5efc4dfe = () => interopDefault(import('../pages/products/_slug.vue' /* webpackChunkName: "pages/products/_slug" */))
const _22a5fefd = () => interopDefault(import('../pages/legacy/Recipe/_slug.vue' /* webpackChunkName: "pages/legacy/Recipe/_slug" */))
const _3ed5a82e = () => interopDefault(import('../pages/recipes/_slug.vue' /* webpackChunkName: "pages/recipes/_slug" */))
const _4738b7f4 = () => interopDefault(import('../pages/search/_term.vue' /* webpackChunkName: "pages/search/_term" */))
const _47d081c9 = () => interopDefault(import('../pages/legacy/Survey/_slug.vue' /* webpackChunkName: "pages/legacy/Survey/_slug" */))
const _69957d46 = () => interopDefault(import('../pages/legacy/SurveyResult/_slug.vue' /* webpackChunkName: "pages/legacy/SurveyResult/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _45f27b28,
    name: "checkout___fr"
  }, {
    path: "/checkout-workshop",
    component: _b2b97288,
    name: "checkout-workshop___fr"
  }, {
    path: "/en",
    component: _131a4860,
    name: "index___en"
  }, {
    path: "/it",
    component: _131a4860,
    name: "index___it"
  }, {
    path: "/login",
    component: _467c2912,
    name: "login___fr"
  }, {
    path: "/my-account",
    component: _01107f6e,
    children: [{
      path: "",
      component: _09a1891e,
      name: "my-account___fr"
    }, {
      path: "loyalty-card",
      component: _165f5730,
      name: "my-account-loyalty-card___fr"
    }, {
      path: "my-addresses",
      component: _bdbca01c,
      name: "my-account-my-addresses___fr"
    }, {
      path: "my-profile",
      component: _b9d69f0e,
      name: "my-account-my-profile___fr"
    }, {
      path: "notebook",
      component: _11ef648c,
      name: "my-account-notebook___fr"
    }, {
      path: "order-history",
      component: _3ebc9a92,
      name: "my-account-order-history___fr"
    }, {
      path: "referral",
      component: _08b28d4e,
      name: "my-account-referral___fr"
    }, {
      path: "wishlist",
      component: _7b0e7376,
      name: "my-account-wishlist___fr"
    }, {
      path: "notebook-details/:slug?",
      component: _496fc3fc,
      name: "my-account-notebook-details-slug___fr"
    }, {
      path: "order-historical-details/:id?",
      component: _396ec67a,
      name: "my-account-order-historical-details-id___fr"
    }, {
      path: "order-history/:id?",
      component: _2b9af6df,
      name: "my-account-order-history-id___fr"
    }]
  }, {
    path: "/reset-password",
    component: _0a95363b,
    name: "reset-password___fr"
  }, {
    path: "/set-password",
    component: _694b1888,
    name: "set-password___fr"
  }, {
    path: "/signin",
    component: _1981cbf8,
    name: "signin___fr"
  }, {
    path: "/signup",
    component: _07d5707a,
    name: "signup___fr"
  }, {
    path: "/survey",
    component: _0c1b0d4b,
    name: "legacy-Survey-Survey___fr"
  }, {
    path: "/tous-nos-conseils",
    component: _329b96dd,
    name: "all-advices___fr"
  }, {
    path: "/tous-nos-produits",
    component: _7a61f4be,
    name: "legacy-AllProducts___fr"
  }, {
    path: "/checkout/thank-you",
    component: _640f7fee,
    name: "legacy-ThankYou___fr"
  }, {
    path: "/dev/error",
    component: _a30923c8,
    name: "dev-error___fr"
  }, {
    path: "/en/all-our-advices",
    component: _329b96dd,
    name: "all-advices___en"
  }, {
    path: "/en/all-our-products",
    component: _7a61f4be,
    name: "legacy-AllProducts___en"
  }, {
    path: "/en/checkout",
    component: _45f27b28,
    name: "checkout___en"
  }, {
    path: "/en/checkout-workshop",
    component: _b2b97288,
    name: "checkout-workshop___en"
  }, {
    path: "/en/guides",
    component: _2b3a1cd9,
    name: "guides___en"
  }, {
    path: "/en/login",
    component: _467c2912,
    name: "login___en"
  }, {
    path: "/en/my-account",
    component: _01107f6e,
    children: [{
      path: "",
      component: _09a1891e,
      name: "my-account___en"
    }, {
      path: "loyalty-card",
      component: _165f5730,
      name: "my-account-loyalty-card___en"
    }, {
      path: "my-addresses",
      component: _bdbca01c,
      name: "my-account-my-addresses___en"
    }, {
      path: "my-profile",
      component: _b9d69f0e,
      name: "my-account-my-profile___en"
    }, {
      path: "notebook",
      component: _11ef648c,
      name: "my-account-notebook___en"
    }, {
      path: "order-history",
      component: _3ebc9a92,
      name: "my-account-order-history___en"
    }, {
      path: "referral",
      component: _08b28d4e,
      name: "my-account-referral___en"
    }, {
      path: "wishlist",
      component: _7b0e7376,
      name: "my-account-wishlist___en"
    }, {
      path: "notebook-details/:slug?",
      component: _496fc3fc,
      name: "my-account-notebook-details-slug___en"
    }, {
      path: "order-historical-details/:id?",
      component: _396ec67a,
      name: "my-account-order-historical-details-id___en"
    }, {
      path: "order-history/:id?",
      component: _2b9af6df,
      name: "my-account-order-history-id___en"
    }]
  }, {
    path: "/en/reset-password",
    component: _0a95363b,
    name: "reset-password___en"
  }, {
    path: "/en/set-password",
    component: _694b1888,
    name: "set-password___en"
  }, {
    path: "/en/signin",
    component: _1981cbf8,
    name: "signin___en"
  }, {
    path: "/en/signup",
    component: _07d5707a,
    name: "signup___en"
  }, {
    path: "/en/survey",
    component: _0c1b0d4b,
    name: "legacy-Survey-Survey___en"
  }, {
    path: "/info/base-de-connaissance",
    component: _76cdba16,
    name: "legacy-FAQ-Index___fr"
  }, {
    path: "/info/contactez-notre-service-client-ou-nos-experts",
    component: _82975c32,
    name: "legacy-FAQ-ContactForm___fr"
  }, {
    path: "/it/checkout",
    component: _45f27b28,
    name: "checkout___it"
  }, {
    path: "/it/checkout-workshop",
    component: _b2b97288,
    name: "checkout-workshop___it"
  }, {
    path: "/it/guides",
    component: _2b3a1cd9,
    name: "guides___it"
  }, {
    path: "/it/login",
    component: _467c2912,
    name: "login___it"
  }, {
    path: "/it/my-account",
    component: _01107f6e,
    children: [{
      path: "",
      component: _09a1891e,
      name: "my-account___it"
    }, {
      path: "loyalty-card",
      component: _165f5730,
      name: "my-account-loyalty-card___it"
    }, {
      path: "my-addresses",
      component: _bdbca01c,
      name: "my-account-my-addresses___it"
    }, {
      path: "my-profile",
      component: _b9d69f0e,
      name: "my-account-my-profile___it"
    }, {
      path: "notebook",
      component: _11ef648c,
      name: "my-account-notebook___it"
    }, {
      path: "order-history",
      component: _3ebc9a92,
      name: "my-account-order-history___it"
    }, {
      path: "referral",
      component: _08b28d4e,
      name: "my-account-referral___it"
    }, {
      path: "wishlist",
      component: _7b0e7376,
      name: "my-account-wishlist___it"
    }, {
      path: "notebook-details/:slug?",
      component: _496fc3fc,
      name: "my-account-notebook-details-slug___it"
    }, {
      path: "order-historical-details/:id?",
      component: _396ec67a,
      name: "my-account-order-historical-details-id___it"
    }, {
      path: "order-history/:id?",
      component: _2b9af6df,
      name: "my-account-order-history-id___it"
    }]
  }, {
    path: "/it/reset-password",
    component: _0a95363b,
    name: "reset-password___it"
  }, {
    path: "/it/set-password",
    component: _694b1888,
    name: "set-password___it"
  }, {
    path: "/it/signin",
    component: _1981cbf8,
    name: "signin___it"
  }, {
    path: "/it/signup",
    component: _07d5707a,
    name: "signup___it"
  }, {
    path: "/it/survey",
    component: _0c1b0d4b,
    name: "legacy-Survey-Survey___it"
  }, {
    path: "/it/tutti-i-nostri-consigli",
    component: _329b96dd,
    name: "all-advices___it"
  }, {
    path: "/it/tutti-nostri-prodotti",
    component: _7a61f4be,
    name: "legacy-AllProducts___it"
  }, {
    path: "/surveyresults/skincare",
    component: _3b7f48c8,
    name: "legacy-Survey-SurveyResult___fr"
  }, {
    path: "/en/checkout/thank-you",
    component: _640f7fee,
    name: "legacy-ThankYou___en"
  }, {
    path: "/en/dev/error",
    component: _a30923c8,
    name: "dev-error___en"
  }, {
    path: "/en/info/base-de-connaissance",
    component: _76cdba16,
    name: "legacy-FAQ-Index___en"
  }, {
    path: "/en/info/contact-us",
    component: _82975c32,
    name: "legacy-FAQ-ContactForm___en"
  }, {
    path: "/en/surveyresults/skincare",
    component: _3b7f48c8,
    name: "legacy-Survey-SurveyResult___en"
  }, {
    path: "/info/guide-des-huiles-essentielles/tous",
    component: _2b3a1cd9,
    name: "guides___fr"
  }, {
    path: "/it/checkout/thank-you",
    component: _640f7fee,
    name: "legacy-ThankYou___it"
  }, {
    path: "/it/dev/error",
    component: _a30923c8,
    name: "dev-error___it"
  }, {
    path: "/it/info/base-de-connaissance",
    component: _76cdba16,
    name: "legacy-FAQ-Index___it"
  }, {
    path: "/it/info/contattare-il-servizio-clienti",
    component: _82975c32,
    name: "legacy-FAQ-ContactForm___it"
  }, {
    path: "/it/surveyresults/skincare",
    component: _3b7f48c8,
    name: "legacy-Survey-SurveyResult___it"
  }, {
    path: "/legacy/Basic/Basic",
    component: _4e5d0669,
    name: "legacy-Basic-Basic___fr"
  }, {
    path: "/legacy/Recipe/Recipe",
    component: _c1a4aa6a,
    name: "legacy-Recipe-Recipe___fr"
  }, {
    path: "/legacy/Recipe/RecipeScript",
    component: _6de2820f,
    name: "legacy-Recipe-RecipeScript___fr"
  }, {
    path: "/legacy/SearchResults/SearchResultsEmpty",
    component: _6a880d14,
    name: "legacy-SearchResults-SearchResultsEmpty___fr"
  }, {
    path: "/legacy/Survey/SurveyResultScript",
    component: _74c51a32,
    name: "legacy-Survey-SurveyResultScript___fr"
  }, {
    path: "/legacy/Survey/TabComponent",
    component: _3dd485ce,
    name: "legacy-Survey-TabComponent___fr"
  }, {
    path: "/legacy/SurveyResult/GenericSurveyResultScript",
    component: _1a40ec10,
    name: "legacy-SurveyResult-GenericSurveyResultScript___fr"
  }, {
    path: "/en/legacy/Basic/Basic",
    component: _4e5d0669,
    name: "legacy-Basic-Basic___en"
  }, {
    path: "/en/legacy/Recipe/Recipe",
    component: _c1a4aa6a,
    name: "legacy-Recipe-Recipe___en"
  }, {
    path: "/en/legacy/Recipe/RecipeScript",
    component: _6de2820f,
    name: "legacy-Recipe-RecipeScript___en"
  }, {
    path: "/en/legacy/SearchResults/SearchResultsEmpty",
    component: _6a880d14,
    name: "legacy-SearchResults-SearchResultsEmpty___en"
  }, {
    path: "/en/legacy/Survey/SurveyResultScript",
    component: _74c51a32,
    name: "legacy-Survey-SurveyResultScript___en"
  }, {
    path: "/en/legacy/Survey/TabComponent",
    component: _3dd485ce,
    name: "legacy-Survey-TabComponent___en"
  }, {
    path: "/en/legacy/SurveyResult/GenericSurveyResultScript",
    component: _1a40ec10,
    name: "legacy-SurveyResult-GenericSurveyResultScript___en"
  }, {
    path: "/it/legacy/Basic/Basic",
    component: _4e5d0669,
    name: "legacy-Basic-Basic___it"
  }, {
    path: "/it/legacy/Recipe/Recipe",
    component: _c1a4aa6a,
    name: "legacy-Recipe-Recipe___it"
  }, {
    path: "/it/legacy/Recipe/RecipeScript",
    component: _6de2820f,
    name: "legacy-Recipe-RecipeScript___it"
  }, {
    path: "/it/legacy/SearchResults/SearchResultsEmpty",
    component: _6a880d14,
    name: "legacy-SearchResults-SearchResultsEmpty___it"
  }, {
    path: "/it/legacy/Survey/SurveyResultScript",
    component: _74c51a32,
    name: "legacy-Survey-SurveyResultScript___it"
  }, {
    path: "/it/legacy/Survey/TabComponent",
    component: _3dd485ce,
    name: "legacy-Survey-TabComponent___it"
  }, {
    path: "/it/legacy/SurveyResult/GenericSurveyResultScript",
    component: _1a40ec10,
    name: "legacy-SurveyResult-GenericSurveyResultScript___it"
  }, {
    path: "/",
    component: _131a4860,
    name: "index___fr"
  }, {
    path: "/en/category/:slug",
    component: _7a9be437,
    name: "legacy-GenericCategory-GenericCategory___en"
  }, {
    path: "/en/content/:slug",
    component: _0a59a7e5,
    name: "legacy-Basic-slug___en"
  }, {
    path: "/en/guide/:slug?",
    component: _e4236976,
    name: "guide-slug___en"
  }, {
    path: "/en/invoice/:id",
    component: _2b0c29d4,
    name: "legacy-Invoice-id___en"
  }, {
    path: "/en/page/:slug?",
    component: _3ade256c,
    name: "page-slug___en"
  }, {
    path: "/en/pages/:slug?",
    component: _607ea60d,
    name: "pages-slug___en"
  }, {
    path: "/en/product/:slug",
    component: _0ceec3f8,
    name: "product-slug___en"
  }, {
    path: "/en/products/:slug?",
    component: _5efc4dfe,
    name: "products-slug___en"
  }, {
    path: "/en/recipe/:slug",
    component: _22a5fefd,
    name: "legacy-Recipe-slug___en"
  }, {
    path: "/en/recipes/:slug?",
    component: _3ed5a82e,
    name: "recipes-slug___en"
  }, {
    path: "/en/search/:term?",
    component: _4738b7f4,
    name: "search-term___en"
  }, {
    path: "/en/survey/:slug",
    component: _47d081c9,
    name: "legacy-Survey-slug___en"
  }, {
    path: "/en/surveyresults/:slug",
    component: _69957d46,
    name: "legacy-SurveyResult-slug___en"
  }, {
    path: "/info/fiche-technique/:slug",
    component: _0ceec3f8,
    name: "product-slug___fr"
  }, {
    path: "/it/category/:slug",
    component: _7a9be437,
    name: "legacy-GenericCategory-GenericCategory___it"
  }, {
    path: "/it/content/:slug",
    component: _0a59a7e5,
    name: "legacy-Basic-slug___it"
  }, {
    path: "/it/guide/:slug?",
    component: _e4236976,
    name: "guide-slug___it"
  }, {
    path: "/it/invoice/:id",
    component: _2b0c29d4,
    name: "legacy-Invoice-id___it"
  }, {
    path: "/it/page/:slug?",
    component: _3ade256c,
    name: "page-slug___it"
  }, {
    path: "/it/pages/:slug?",
    component: _607ea60d,
    name: "pages-slug___it"
  }, {
    path: "/it/product/:slug",
    component: _0ceec3f8,
    name: "product-slug___it"
  }, {
    path: "/it/products/:slug?",
    component: _5efc4dfe,
    name: "products-slug___it"
  }, {
    path: "/it/recipe/:slug",
    component: _22a5fefd,
    name: "legacy-Recipe-slug___it"
  }, {
    path: "/it/recipes/:slug?",
    component: _3ed5a82e,
    name: "recipes-slug___it"
  }, {
    path: "/it/search/:term?",
    component: _4738b7f4,
    name: "search-term___it"
  }, {
    path: "/it/survey/:slug",
    component: _47d081c9,
    name: "legacy-Survey-slug___it"
  }, {
    path: "/it/surveyresults/:slug",
    component: _69957d46,
    name: "legacy-SurveyResult-slug___it"
  }, {
    path: "/category/:slug",
    component: _7a9be437,
    name: "legacy-GenericCategory-GenericCategory___fr"
  }, {
    path: "/content/:slug",
    component: _0a59a7e5,
    name: "legacy-Basic-slug___fr"
  }, {
    path: "/guide/:slug?",
    component: _e4236976,
    name: "guide-slug___fr"
  }, {
    path: "/invoice/:id",
    component: _2b0c29d4,
    name: "legacy-Invoice-id___fr"
  }, {
    path: "/page/:slug?",
    component: _3ade256c,
    name: "page-slug___fr"
  }, {
    path: "/pages/:slug?",
    component: _607ea60d,
    name: "pages-slug___fr"
  }, {
    path: "/products/:slug?",
    component: _5efc4dfe,
    name: "products-slug___fr"
  }, {
    path: "/recipe/:slug",
    component: _22a5fefd,
    name: "legacy-Recipe-slug___fr"
  }, {
    path: "/recipes/:slug?",
    component: _3ed5a82e,
    name: "recipes-slug___fr"
  }, {
    path: "/search/:term?",
    component: _4738b7f4,
    name: "search-term___fr"
  }, {
    path: "/survey/:slug",
    component: _47d081c9,
    name: "legacy-Survey-slug___fr"
  }, {
    path: "/surveyresults/:slug",
    component: _69957d46,
    name: "legacy-SurveyResult-slug___fr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
